import Application from "../../Application";
import GetFactsInteractor from "./GetFactsInteractor";
import FactsPresenter, {
  IFactsPresenter
} from "../../presenter/evaluation/FactsPresenter";

export default class ShowFactsInteractor {
  private application: Application;
  private getFacts: GetFactsInteractor;
  private output?: IFactsPresenter;

  constructor(application, getFacts) {
    this.application = application;
    this.getFacts = getFacts;
  }

  execute() {
    this.output = FactsPresenter({
      application: this.application,
      initialState: {
        facts: []
      }
    });

    this.getFacts.execute().then(this.output.setFacts);

    return this.output;
  }
}
